import { DeploymentMode, runtimeCapabilities } from '@/config/runtimeCapabilities';

export type DefaultValuesFile = 'method' | 'postprocessingTemplate';

const LOCAL_DEFAULT_VALUES_URLS: Record<DefaultValuesFile, string> = {
  method: '/app-defaults/method_default_values.json',
  postprocessingTemplate: '/app-defaults/postprocessing-template_default_values.json',
};

const REMOTE_DEFAULT_VALUES_URLS: Record<DefaultValuesFile, string> = {
  method: 'https://get.chrom.app/method_default_values.json',
  postprocessingTemplate: 'https://get.chrom.app/postprocessing-template_default_values.json',
};

export const getDefaultValuesUrl = (
  deploymentMode: DeploymentMode,
  file: DefaultValuesFile,
): string =>
  (deploymentMode === 'offline' ? LOCAL_DEFAULT_VALUES_URLS : REMOTE_DEFAULT_VALUES_URLS)[file];

export const getCurrentDefaultValuesUrl = (file: DefaultValuesFile): string =>
  getDefaultValuesUrl(runtimeCapabilities.deploymentMode, file);
